import { Button } from '@heroui/button'
import { Link } from '@heroui/link'

import { Typography } from '@/components/ui'

import { ArrowLeftIcon } from '..'

interface BackButtonProps {
  title: string
  route: string
}

const BackButton = ({ title, route }: BackButtonProps) => {
  return (
    <div className="flex w-full items-center gap-4">
      <Button
        as={Link}
        href={route}
        isIconOnly
        size="md"
        variant="solid"
        className="rounded-full bg-default-100"
      >
        <ArrowLeftIcon className="text-2xl" />
      </Button>
      <Typography
        size="xlarge"
        weight="medium"
        className="font-crimsonPro text-default-foreground"
      >
        {title}
      </Typography>
    </div>
  )
}

export default BackButton
